import {COUNT_DIGITS} from "../../../analytics/constants";

export const calcMercariFees = (soldPrice) => {
    const MERCARI_FEES_VALUE_PERCENT = 0.1
    const mercariFees = +soldPrice * MERCARI_FEES_VALUE_PERCENT
    return mercariFees.toFixed(COUNT_DIGITS)
}